import React from 'react';

import {
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaHome,
    FaInfoCircle,
    FaWrench,
    FaPhoneAlt,
    FaLinkedin,
} from 'react-icons/fa';
const { useState } = React;

function SidebarItem({ icon, label, url, children }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            <div className="eb-garamond text-lg font-semibold flex items-center p-2 text-white cursor-pointer py-4 background-with-image-blue" onClick={() => setIsOpen(!isOpen)}>
                <i className={`fas ${icon} mr-2`}></i>
                <a href={url}><span>{label}</span></a>
                {children && (
                    <i className={`fas ml-auto ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                )}
            </div>
            {isOpen && children && (
                <div className="pl-8">
                    {children}
                </div>
            )}
        </div>
    );
}

function Sidebar(props) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const color = props.color;
    const pageName = props.pageName;
    return (
        <div className="mobile-nav">
            {isSidebarOpen && (

                <div className="fixed inset-0 bg-white bg-opacity-50 z-10" onClick={() => setIsSidebarOpen(false)}></div>
            )}
            <div className={`text-black fixed inset-y-0 right-0 background-with-image-blue ${isSidebarOpen ? 'w-64' : 'w-0'} transition-width duration-300 overflow-hidden z-20`}>
                <div className="">
                    <div className="flex items-center justify-between mb-6 p-4">
                        {/* <div className="flex items-center"> 
                                <img src={require('../images/logo@2x-free-img-120x40.png')} alt="Logo" className="w-auto h-auto"  /> 
                        </div> */}
                        <button className="text-black ml-auto" onClick={() => setIsSidebarOpen(false)}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    {/* <SidebarItem icon="fa-th-large" label="Dashboard">
                        <div className="text-white p-2 hover:bg-gray-700">Default</div>
                        <div className="text-white p-2 hover:bg-gray-700">Analytic</div>
                        <div className="text-white p-2 hover:bg-gray-700">Saas</div>
                    </SidebarItem> */}
                    <SidebarItem icon="" label="Services" url="/" />
                    <SidebarItem icon="" label="About" url="/About" />
                    <SidebarItem icon="" label="Contact Us" url="/Contact" />
                </div>
            </div>
            <div className="absolute w-full flex justify-between bg-[transparent] pl-2 pr-4 pb-4 z-50">
                <div className={`bg-[transparent] flex space-x-2 mt-8 rounded ${color == "blue" ? "text-[#80a2a5]" : "text-white"}`} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                    <a href="#" aria-label="Facebook" className='text-3xl ' >
                        <FaFacebook />
                    </a>
                    <a href="#" aria-label="Instagram" className='text-3xl '>
                        <FaInstagram />
                    </a>
                    <a href="#" aria-label="LinkedIn" className='text-3xl '>
                        <FaLinkedin />
                    </a>
                </div>
                <div className='flex'>
                    <a href="/" className='text-3xl '>
                        {color == "blue" &&
                            <img src={require('../images/12.png')} alt="DHA Karachi logo" className="w-[80px] mt-4" />
                        }
                        {color !== "blue" && pageName !=="Home" &&
                            <img src={require('../images/Logo.png')} alt="DHA Karachi logo" className="w-[80px] mt-4" />
                        }
                        {color !== "blue" && pageName =="Home" &&
                            <img src={require('../images/12.png')} alt="DHA Karachi logo" className="w-[80px] mt-4" />
                        }
                    </a>
                </div>
            </div>
        </div>
    );
}
export default Sidebar;
